import { api } from '@/services/api';
import {
  LeaderboardOverview,
  LeaderboardPayout,
  LeaderboardScheduleInfo,
  UpdateLeaderboardConfigBody,
  UpdateLeaderboardScheduleBody,
} from '@repo/common-types';

export const getLeaderboardPayoutsRest = async (startDate?: Date) => {
  const response = await api.get<LeaderboardPayout[]>(`/v1/admin/leaderboard/payouts/${startDate?.toISOString()}`);
  return response.data;
};

export const retryFailedPayoutRest = async (txId: string) => {
  const response = await api.post(`/v1/admin/leaderboard/retry-leaderboard-payout`, { txId });
  return response.data;
};

export const getLeaderboardConfigRest = async (): Promise<LeaderboardOverview> => {
  const response = await api.get<LeaderboardOverview>(`/v1/admin/leaderboard/config`);
  return response.data;
};

export const updateLeaderboardConfigRest = async (payload: UpdateLeaderboardConfigBody) => {
  const response = await api.patch<UpdateLeaderboardConfigBody>('/v1/admin/leaderboard/config', payload);
  return response.data;
};

export const getLeaderboardScheduleRest = async (): Promise<LeaderboardScheduleInfo | null> => {
  const response = await api.get<LeaderboardScheduleInfo>(`/v1/admin/leaderboard/schedule`);
  return response.data;
};

export const updateLeaderboardScheduleRest = async (
  payload: UpdateLeaderboardScheduleBody,
): Promise<LeaderboardScheduleInfo | null> => {
  const response = await api.post<LeaderboardScheduleInfo>('/v1/admin/leaderboard/schedule', payload);
  return response.data;
};
